import ronit from "../Images/ronit.jpg"
import vasu from "../Images/vasu.jpg"
import pratyush from "../Images/pratyush.jpg"

export const TeamData = [
    {
        key: 0,
        imgUrl: vasu,
        name: 'Vasu Dutt',
        prof: 'Web Dev',
        loc: 'Ghaziabad, India',
        college: 'KIIT Bhubaneswar',
        github: 'https://github.com/vasudutt',
        linkedin: 'https://www.linkedin.com/in/vasu-dutt/'
    },
    {
        key: 1,
        imgUrl: pratyush,
        name: 'Pratyush Patnaik',
        prof: 'ML/AI, Web Dev',
        loc: 'Bhubaneswar, India',
        college: 'KIIT Bhubaneswar',
        github: 'https://github.com/Pratyush-exe',
        linkedin: 'https://www.linkedin.com/in/pratyush-patnaik-1394a91b8/'
    },
    {
        key: 2,
        imgUrl: ronit,
        name: 'Ronit Kamilla',
        prof: 'Web Dev',
        loc: 'Bhubaneswar, India',
        college: 'KIIT Bhubaneswar',
        github: 'https://github.com/ronit01',
        linkedin: 'https://www.linkedin.com/in/ronit-kamilla-981433215/'
    }
]